module.exports = __webpack_public_path__ + "img/3x.d80ef85.jpg";